import videojs from 'video.js';

const icon = `<svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.944851 7.93503C0.866644 5.13484 2.22067 2.5831 5.12098 1.96987C8.02129 1.35665 10.8897 3.11915 11.5278 5.90652C12.1658 3.11915 15.0343 1.35665 17.9346 1.96987C20.8349 2.5831 22.2941 5.2198 22.0307 8.12719C21.9133 11.4919 17.8295 15.3949 11.5278 19.8362C4.52581 15.3949 0.944851 12.0009 0.944851 7.96333V7.93503Z" stroke="white" stroke-width="0.960174" stroke-linejoin="round"/></svg>`;

class AddLike extends videojs.getComponent('Button') {
    constructor(player, options) {
        super(player, options);
        this.addClass('vjs-likes__button');
        this.el().insertAdjacentHTML('beforeend', icon);
        this.hide();
        player.on('ready', () => {
            this.options_.chatApi.on('newLike', () => {
                player.getChild('Likes').getChild('Bubbles').create();
            });
        });
        player.one('playing', () => this.show());
    }

    handleClick() {
        this.options_.chatApi.sendLike();
    }
}

videojs.getComponent('Component').registerComponent('AddLike', AddLike);
